import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';

import { Article } from '~marketing/components/article';
import PrivacyContent from '~marketing/mdx/privacy-policy.mdx';
import { buildPageHead } from '~marketing/utils/build-page-head';
import { getTranslator } from '~marketing/utils/get-translator';

export const Route = createFileRoute('/_public/legal/privacy-policy')({
  head: ({ match }) =>
    buildPageHead({
      path: match.pathname,
      title: getTranslator()('privacyPolicy'),
    }),
  component: PrivacyPolicyRoute,
});

function PrivacyPolicyRoute() {
  const t = useTranslations();
  return (
    <div className="container">
      <Article title={t('privacyPolicy')} dir="ltr" lang="en">
        <PrivacyContent />
      </Article>
    </div>
  );
}
